import * as React from "react"
import { ChakraProvider } from "@chakra-ui/react"
import theme from "./theme"

interface WrapRootElementProps {
  element: React.ReactNode
}

export const WrapRootElement: React.FC<WrapRootElementProps> = ({ element }) => (
  <ChakraProvider theme={theme}>{element}</ChakraProvider>
);